// =====================================
//
//   FAQ Controller
//   Author: Wayne
//   createtime: 2016 / 09 / 07
//
// =====================================

window.InifECMobileApp.controller("SystemMessageController", ['$scope', '$state', '$timeout', '$rootScope', 'MessageService', '$PreviousState',
    function($scope, $state, $timeout, $rootScope, MessageService, $PreviousState) {

        // --------------------------------
        // [private] 取得所有系統通知訊息以及最後讀取時間
        // --------------------------------
        var getAllMsgs = function() {

            $scope.isLoading = true;
            
            MessageService.getAllMsgs().then(function(result) {

                if(result && result.msgs && result.msgs.length) {

                    for(var i = 0; i < result.msgs.length; i++) {
                        var message = result.msgs[i];

                        message.content.simpleTitle = simpleTitle(message.content.title);
                        $scope.messageList.push(message);
                    }

                } else if($scope.messageList.length == 0) {
                    $scope.isEmpty = true;
                }

                $scope.isLoading = false;

            }, function(error) {

                $scope.isError = true;
                $scope.isLoading = false;
            });
        }

        var simpleTitle = function(title){
            var text = title.replace("。","");

            var indexFrom = text.indexOf("「");
            var indexTo = text.indexOf("」");

            if(indexFrom > -1 && indexTo > -1){
                text = text.slice(0,indexFrom) + text.slice(indexTo+1,text.length);
            }

            return text;
        }

        var getMessageImage = function(message) {

            if(!message || !message.content || !message.content.coverurl) {
                return "about:blank";
            }

            return message.content.coverurl.replace('medium', 'small');
        }

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {

            var backState = $PreviousState.getSystemMessagePrevious();

            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {

            getAllMsgs();
        }

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.messageList = [];

        //==========================
        //  Methods
        //==========================
        $scope.goBack = goBack;
        $scope.getMessageImage = getMessageImage;

        //==========================
        //  Init
        //==========================
        init();
    }
]);